import { useEffect, useState } from "react";
import { resultCountFromPage } from "../utils/resultCount";
/** Long enough that typing a rating doesn't fire a request per keystroke. */
const DEBOUNCE_MS = 350;
/**
 * How many players a set of filters would return, for a filters header
 * ("2 active · 1,420+ players"). The caller fetches the first page; `key` is
 * the filters serialised, so the effect follows their content rather than an
 * object rebuilt on every keystroke.
 *
 * Debounced, and late answers are dropped: filters change faster than the
 * network replies, and a stale count is worse than none. A failed request
 * clears the count instead of surfacing an error.
 */
export function useResultCount({ key, enabled = true, fetchFirstPage, }) {
    const [result, setResult] = useState();
    useEffect(() => {
        if (!enabled)
            return;
        let cancelled = false;
        const timer = setTimeout(() => {
            fetchFirstPage()
                .then(({ players, totalPages }) => {
                if (cancelled)
                    return;
                setResult(resultCountFromPage({ playersOnPage: players.length, totalPages }));
            })
                .catch(() => {
                if (!cancelled)
                    setResult(undefined);
            });
        }, DEBOUNCE_MS);
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
        // The request is read through `key`, which is what actually changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, enabled]);
    return result;
}
//# sourceMappingURL=useResultCount.js.map